// Match this import to the shared Supabase client used by your invoiceService.js.
import supabase from '../supabase/supabase';

const table = () => supabase.schema('accounting').from('vendors');

const ensureOrg = (organizationId) => {
  if (!organizationId) throw new Error('Select a business first.');
};

const writable = [
  'vendor_name', 'company_name', 'email', 'phone', 'website',
  'billing_address_line1', 'billing_address_line2', 'billing_city',
  'billing_state', 'billing_postal_code', 'billing_country',
  'payment_terms', 'currency', 'tax_id', 'notes', 'is_active'
];

function cleanPayload(data) {
  const result = {};
  for (const key of writable) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      result[key] = typeof value === 'string' ? value.trim() : value;
    }
  }
  if ('vendor_name' in result && !result.vendor_name) {
    throw new Error('Vendor name is required.');
  }
  return result;
}

function unwrap({ data, error }) {
  if (error) throw error;
  return data;
}

export const vendorService = {
  async getVendors(organizationId) {
    ensureOrg(organizationId);
    return unwrap(await table()
      .select('*')
      .eq('organization_id', organizationId)
      .order('vendor_name', { ascending: true }));
  },

  async getVendorById(organizationId, vendorId) {
    ensureOrg(organizationId);
    if (!vendorId) throw new Error('Vendor ID is required.');
    return unwrap(await table()
      .select('*')
      .eq('organization_id', organizationId)
      .eq('id', vendorId)
      .single());
  },

  async createVendor(organizationId, vendorData) {
    ensureOrg(organizationId);
    return unwrap(await table()
      .insert({ ...cleanPayload(vendorData), organization_id: organizationId })
      .select('*')
      .single());
  },

  async updateVendor(organizationId, vendorId, vendorData) {
    ensureOrg(organizationId);
    if (!vendorId) throw new Error('Vendor ID is required.');
    return unwrap(await table()
      .update(cleanPayload(vendorData))
      .eq('organization_id', organizationId)
      .eq('id', vendorId)
      .select('*')
      .single());
  },

  async setVendorActive(organizationId, vendorId, isActive) {
    return this.updateVendor(organizationId, vendorId, { is_active: Boolean(isActive) });
  }
};